import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect, useState, useRef } from 'react'; 
import Skeleton from '@mui/material/Skeleton';

const TableDropdownWithObjCopy = ({ tag, objKey, list, setList, count, length, optionsList, width, font, showError, disableEdit, isLoading, overrideBlank, changeFunction=()=>{return}}) =>{
    // initialize state
    const [value, setValue] = useState({}); 
    // initialize ref
    const ref = useRef();

    // set width if not given as prop
    if (width == null){
        width = '16.6vw';
    }

    // set font size if given as prop, else use default
    let style = {};
    if (font != null){
        style['fontSize'] = font;
    }

    // event handler to set value on dropdown change
    const onDropdownChange = (e) =>{
        // set display value
        setValue(value => value = e.target.value);
        // set object in list with value
        if (overrideBlank == true || list[count]['blank'] == false) {
            let temp = list; 
            temp[count][objKey] = e.target.value; 
            setList(list => list = temp );
            console.log(temp); 
        }
        // run change function 
        changeFunction(e.target.value); 
    }

    // handle showing error and setting focus
    const [error, setError] = useState(); 
    useEffect(() => {
        if (showError && showError == true) { 
            // set show error
            setError(error => error = true); 
            // focus on error element 
            ref.current.focus();
        }
        else {
            setError(error => error = false); 
        }
    }, [showError]); 

    // update display on length change
    useEffect(() => {
        console.log(list[count][objKey]); 
        setValue(value => value = list[count][objKey]); 
    }, [length]); 

    return(
        <> 
            { isLoading ? 
            <>
                <Skeleton variant="rectangular" width='100%' height={'40px'} sx={{ borderRadius: '5px' }}/>
            </>
            : /* material ui dropdown component */
            <FormControl fullWidth size='small' sx={{ width: width, maxWidth: width , "& .MuiInputBase-root": {
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "24px",
                // backgroundColor: "white",
                fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
                },}}>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value}
                    style={style}                 
                    onChange={(e)=>onDropdownChange(e)}
                    error={error}
                    inputRef={ref} 
                    readOnly={disableEdit}  
                >
                    {optionsList.map( el =>    
                        <MenuItem 
                            sx={{"&.Mui-selected": {
                                backgroundColor: "#E6EDF1",
                            },
                            "&.Mui-selected:focus": {
                                backgroundColor: "#E6EDF1",
                            },
                            "&.MuiMenuItem-root": {
                                fontSize: "14px",
                                borderBottom: "1px solid #E6EDF1",
                                fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
                            },}}
                        style={style} key={el['id']} id={el['id']} value={el}>{el['label']}</MenuItem>
                    )}
                </Select>
            </FormControl>
            }
        </>
    );
}

export default TableDropdownWithObjCopy;